import { Component } from 'react';
import cx from 'classnames';

import styles from '../../styles/plan/fundSummary.scss';
import SectionHeader from './sectionHeader';
import { returnsLabels, fundMetaDataMap } from '../../constants';
import Table from '../common/table';

const Selector = (props: any) => (
  <div className={styles.selector}>
    <span className={styles.ticker}>
      <select name="fund-select" value={props.fund} onChange={props.selectFund}>
        {props.fundNames.map((fundObj: any) => (
          <option key={fundObj.value} value={fundObj.value}>
            {fundObj.label}
          </option>
        ))}
      </select>
    </span>
  </div>
);

interface Props {
  data: any;
  showTitle?: boolean;
}

interface State {
  fund: number | string;
}

export default class FundSummary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.getStateFromProps(props);
  }

  public UNSAFE_componentWillReceiveProps(nextProps: Props) {
    this.setState(this.getStateFromProps(nextProps));
  }

  // this is an anti-pattern. we should revisit and fix this.
  // refer https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html
  private getStateFromProps(props: Props) {
    const defaultFund =
      props.data && props.data[0] ? props.data[0].productId : null;
    return {
      fund: defaultFund,
    };
  }

  private selectFund = (e: any) => {
    this.setState({
      fund: e.target.value,
    });
  };

  private getData(fundId: number | string) {
    const funds = this.props.data;
    const selectedFundArray = funds.filter(
      (fundObj: any) => fundObj.productId.toString() === fundId.toString()
    );
    return selectedFundArray.length ? selectedFundArray[0] : null;
  }

  private generateFundSelector() {
    return this.props.data.map((fund: any) => ({
      label: fund.fundName,
      value: fund.productId,
    }));
  }

  private generateReturnsData = (returns: any) => {
    const headers = [{ value: 'Period' }, { value: 'Returns (per year)' }];
    const body = Object.keys(returns)
      .map(key =>
        returns[key]
          ? [{ value: returnsLabels[key] }, { value: `${returns[key]}%` }]
          : null
      )
      .filter((obj: any) => !!obj);
    return [headers, ...body];
  };

  private generateMetadata = (metadata: any) => {
    const keysToRender = Object.keys(fundMetaDataMap);
    const headers = [{ value: 'Fund Details', span: 2 }];
    const body = keysToRender
      .map((key: string) => {
        if (!metadata[key]) {
          return;
        }
        return [
          {
            value: fundMetaDataMap[key].label,
            info: fundMetaDataMap[key].info,
          },
          {
            value: fundMetaDataMap[key].formatter
              ? fundMetaDataMap[key].formatter(metadata[key])
              : metadata[key],
            desc: fundMetaDataMap[key].desc,
          },
        ];
      })
      .filter((obj: any) => !!obj);
    return [headers, ...body];
  };

  public render() {
    const { fund } = this.state;
    const { showTitle = true } = this.props;
    const fundNames = this.generateFundSelector();
    const fundData = this.getData(fund);
    if (!fund || !fundData.fundMetaData) {
      return null;
    }
    const returns = fundData.fundMetaData.returns;
    return (
      <div className={cx(styles['fund-summary'], 'fund-summary-block')}>
        {showTitle ? <SectionHeader title="Fund Summary" golden /> : null}
        <div className={cx(styles['content'], !showTitle ? 'mt30' : null)}>
          <Selector
            selectFund={this.selectFund}
            fundNames={fundNames}
            fund={fund}
          />
          <div className={cx(styles.summary, 'row mt10')}>
            <div className="large-6 medium-6 columns">
              <Table data={this.generateReturnsData(returns)} />
            </div>
            <div className="large-6 medium-6 columns">
              <Table data={this.generateMetadata(fundData.fundMetaData)} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/plan/fundSummary.tsx